import { m } from 'framer-motion';
// @mui
import Container from '@mui/material/Container';
import { SxProps, Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
// assets
import { ForbiddenIllustration } from 'src/assets/illustrations';
// components
import { MotionContainer, varBounce } from 'src/components/animate';
import { USER_TYPE } from 'src/types/ApiConstant';
import { useAuthContext } from '../hooks';

// ----------------------------------------------------------------------

type RoleBasedGuardProp = {
  hasContent?: boolean;
  forReader?: boolean;
  roles?: string[];
  rule?: string;
  children: React.ReactNode;
  sx?: SxProps<Theme>;
};

function AccessDenied({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <Container component={MotionContainer} sx={{ textAlign: 'center', ...sx }}>
      <m.div variants={varBounce().in}>
        <Typography variant="h3" sx={{ mb: 2 }}>
          Quyền truy cập bị từ chối !!
        </Typography>
      </m.div>

      <m.div variants={varBounce().in}>
        <Typography sx={{ color: 'text.secondary' }}>
          Bạn không có quyền để truy cập vào trang này !
        </Typography>
      </m.div>

      <m.div variants={varBounce().in}>
        <ForbiddenIllustration
          sx={{
            height: 260,
            my: { xs: 5, sm: 10 },
          }}
        />
      </m.div>
    </Container>
  );
}

export default function RoleBasedGuard({
  hasContent,
  roles,
  rule,
  children,
  sx,
  forReader,
}: RoleBasedGuardProp) {
  const { user } = useAuthContext();
  const currentRules = user?.role;

  const condition =
    (user?.type === USER_TYPE.READER && forReader) || user?.type !== USER_TYPE.READER;

  if (!condition) {
    if (typeof rule !== 'undefined' && !currentRules?.includes(`${rule}`)) {
      return hasContent ? <AccessDenied sx={sx} /> : null;
    }
    return <AccessDenied sx={sx} />;
  }

  return <> {children} </>;
}
